var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 516,
    viewBox: "0 0 513 516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.5,
    cy: 258,
    rx: 256.5,
    ry: 258,
    fill: "#77A02E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.956 209.061L268.496 271.619V84.03C268.496 77.389 263.058 72 256.345 72C249.632 72 244.194 77.39 244.194 84.03V271.619L180.734 209.061C175.994 204.369 168.295 204.369 163.555 209.061C158.815 213.765 158.815 221.38 163.555 226.072L247.755 309.069C250.005 311.319 253.169 312.606 256.345 312.606C259.509 312.606 262.673 311.307 264.935 309.081L349.135 226.084C353.887 221.38 353.875 213.765 349.135 209.073C344.396 204.369 336.696 204.369 331.956 209.061Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125 308.5C122.515 308.5 120.5 310.515 120.5 313V409C120.5 411.485 122.515 413.5 125 413.5H387C389.485 413.5 391.5 411.485 391.5 409V313C391.5 310.515 389.485 308.5 387 308.5H359C356.515 308.5 354.5 310.515 354.5 313V372.5H155.5V313C155.5 310.515 153.485 308.5 151 308.5H125Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 9,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.34b992685432ddcc1fe7dddff0b43a2b.svg";
export { ForwardRef as ReactComponent };